export class Step11 {
    constructor() {}

    intitule = 'stepper.form.mapa_in.step10';
    getidmarche = 'form.mapa_in.getidmarche';
    getconditionsremise = 'form.mapa_in.getconditionsremise';
    getspan17 = 'form.mapa_in.getspan17';
    getoui = 'form.mapa_in.getoui';
    getnon = 'form.mapa_in.getnon';
    getvalue = 'form.mapa_in.getvalue';
    getdevise = 'form.mapa_in.getdevise';
    getdatelimiteobtention = 'form.mapa_in.getdatelimiteobtention';
    getconditionsmodepaiement = 'form.mapa_in.getconditionsmodepaiement';
    getrensgcomplt = 'form.mapa_in.getrensgcomplt';

}
